module.exports = __webpack_public_path__ + "img/use-process-1.8eab0a42.png";